import React, { ChangeEvent, useState } from 'react';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Grid,
  TextField,
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { injectIntl, IntlShape } from 'react-intl';
import DateFnsUtils from '@date-io/date-fns';
import frLocale from 'date-fns/locale/fr';
import moment from 'moment-timezone';

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { get, isEmpty } from 'lodash';
import {
  DATE_FORMAT,
  DATE_PICKET_FORMAT,
  DOCUMENT_TYPES,
} from 'constants/global';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import { JUDGEMENT_INFO_FIELDS } from 'containers/data-structure';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import { translate } from 'containers/services/translate';
import ImportImagineDocumentButton from 'containers/CourtManagerLegalProceedings/ImagineDocuments/ImportButton';
import { resolveSagisClaim } from 'helpers/utils';
import { IJudgementOnMeritsInfo } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/typings';
import {
  IUploadedDocument,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import { LABEL_WIDTH } from 'containers/PreOpeningPage/OpposingParty/constants';
import {
  CORRECTIONAL_DOC_ID,
  JUDGEMENT_ON_MERITS_ADDITIONAL_INFO_NOT_SELECTED,
  JUDGEMENT_ON_MERITS_ADDITIONAL_INFO_SELECTED,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import { JudgementOnMeritsDoc } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { handleOpenDocument } from 'services/utils';
import Document from 'components/Document';
import {
  EMPTY_SUPPORT_DOC,
  SUPPORT_DOC_JUDGEMENT_ON_MERITS_ID,
} from 'containers/LawyerRecapPage/constants';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import { isMonitoringCourtManager } from 'helpers/utils';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';
import DecisionDropDownSupportDocument from 'containers/common/LegalProceedings/DecisionDropDownSupportDocument';
import { PROCEDURE_TYPES } from 'containers/LawyerLegalProceedingsPage/constants';
import {
  STATUS_PENDING,
  STATUS_VALIDATED,
} from 'containers/LawyerFeeNote/constants';

export interface AdditionalInfoJudgementOnMeritFormProps {
  intl: IntlShape;
  additionalJudgementOnMeritsInfoForm: any;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  handleJudgementOnMeritsDocChange: Function;
  documentId: string | undefined;
  setDocumentId: Function;
  judgementOnMeritsFormDocument: JudgementOnMeritsDoc;
  setJudgementOnMeritsFormDocument: Function;
  resetUploadedDocument: Function;
  setAdditionalJudgementOnMeritsInfoForm: Function;
  judgementOnMerits: JudgementOnMeritsType;
  requestAddJudgementOnMeritsSupportDocument: Function;
  claimId?: number;
  claimNumber?: string;
  isAppeal?: boolean;
  isCivilProceeding: boolean;
  isManager?: boolean;
  isAssignedLawyer: boolean;
  isCreator: boolean;
  requestMakeDecisionSupportDocument?: Function;
  judiciaryProcessId: any;
  claim: any;
  imagineDocuments: any;
  listings: any;
  policyInfo: any;
  isConsultation?: boolean;
  requestGetDocByDocumentumId: Function;
}
const AdditionalInfoJudgementOnMeritForm: React.FC<AdditionalInfoJudgementOnMeritFormProps> = ({
  resetUploadedDocument,
  uploadDocument,
  handleJudgementOnMeritsDocChange,
  judgementOnMeritsFormDocument,
  setJudgementOnMeritsFormDocument,
  documentId,
  uploadedDocument,
  setDocumentId,
  additionalJudgementOnMeritsInfoForm,
  judgementOnMerits,
  setAdditionalJudgementOnMeritsInfoForm,
  isCivilProceeding,
  isManager,
  ...props
}): JSX.Element => {
  const [judgementInfo, setJudgementInfo] = useState<IJudgementOnMeritsInfo>({
    [JUDGEMENT_INFO_FIELDS.DEPENS]: '',
    [JUDGEMENT_INFO_FIELDS.COST]: get(
      judgementOnMerits['judgementOnMerits']['jom'],
      'cost',
      '',
    ),
    [JUDGEMENT_INFO_FIELDS.IDD]: '',
    [JUDGEMENT_INFO_FIELDS.DATE]: get(
      judgementOnMerits['judgementOnMerits']['jom'],
      'calculationStartDate',
      '',
    ),
    [JUDGEMENT_INFO_FIELDS.COMMENTARY]: get(
      judgementOnMerits['judgementOnMerits']['jom'],
      'commentary',
      '',
    ),
    [JUDGEMENT_INFO_FIELDS.DEFENSE_TO_EXECUTION]: get(
      judgementOnMerits['judgementOnMerits']['jom'],
      'defenseToExecution',
      false,
    ),
    [JUDGEMENT_INFO_FIELDS.DIFFICULTY_TO_EXECUTION]: get(
      judgementOnMerits['judgementOnMerits']['jom'],
      'difficultyToExecution',
      false,
    ),
  });

  const [depens, setDepens] = useState<unknown>(
    get(judgementOnMerits['judgementOnMerits']['jom'], 'responsibility', '') ===
      'Oui'
      ? 1
      : 0,
  );

  const [idd, setIdd] = useState<unknown>(
    get(judgementOnMerits['judgementOnMerits']['jom'], 'idd', '') === 'Oui'
      ? 1
      : 0,
  );

  const handleChange = (e: ChangeEvent<{ value: string }>) => {
    const { value } = e.target;
    setJudgementInfo({ ...judgementInfo, [JUDGEMENT_INFO_FIELDS.COST]: value });
    setAdditionalJudgementOnMeritsInfoForm({
      ...additionalJudgementOnMeritsInfoForm,
      [JUDGEMENT_INFO_FIELDS.COST]: value,
      [JUDGEMENT_INFO_FIELDS.DEPENS]: JUDGEMENT_ON_MERITS_ADDITIONAL_INFO_SELECTED,
    });
  };

  const handleCheckBoxChangeDefenseToExecution = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { checked } = e.target;
    setJudgementInfo({
      ...judgementInfo,
      [JUDGEMENT_INFO_FIELDS.DEFENSE_TO_EXECUTION]: checked,
    });
    setAdditionalJudgementOnMeritsInfoForm({
      ...additionalJudgementOnMeritsInfoForm,
      [JUDGEMENT_INFO_FIELDS.DEFENSE_TO_EXECUTION]: checked,
    });
  };

  const handleCheckBoxChangeDifficultyToExecution = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { checked } = e.target;
    setJudgementInfo({
      ...judgementInfo,
      [JUDGEMENT_INFO_FIELDS.DIFFICULTY_TO_EXECUTION]: checked,
    });
    setAdditionalJudgementOnMeritsInfoForm({
      ...additionalJudgementOnMeritsInfoForm,
      [JUDGEMENT_INFO_FIELDS.DIFFICULTY_TO_EXECUTION]: checked,
    });
  };

  const handleCommentaryChange = (e: ChangeEvent<{ value: string }>) => {
    const { value } = e.target;
    setJudgementInfo({
      ...judgementInfo,
      [JUDGEMENT_INFO_FIELDS.COMMENTARY]: value,
    });
    setAdditionalJudgementOnMeritsInfoForm({
      ...additionalJudgementOnMeritsInfoForm,
      [JUDGEMENT_INFO_FIELDS.COMMENTARY]: value,
    });
  };

  const handleChangeDate = (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    const judgementDate = moment(theDate as Date).format(DATE_FORMAT);
    setJudgementInfo({
      ...judgementInfo,
      [JUDGEMENT_INFO_FIELDS.DATE]: judgementDate,
    });
    setAdditionalJudgementOnMeritsInfoForm({
      ...additionalJudgementOnMeritsInfoForm,
      [JUDGEMENT_INFO_FIELDS.DATE]: judgementDate,
      [JUDGEMENT_INFO_FIELDS.IDD]: JUDGEMENT_ON_MERITS_ADDITIONAL_INFO_SELECTED,
    });
  };

  const handleDepensChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setDepens(event.target.value);
    if (event.target.value) {
      setAdditionalJudgementOnMeritsInfoForm({
        ...additionalJudgementOnMeritsInfoForm,
        [JUDGEMENT_INFO_FIELDS.DEPENS]: JUDGEMENT_ON_MERITS_ADDITIONAL_INFO_SELECTED,
      });
    } else {
      setAdditionalJudgementOnMeritsInfoForm({
        ...additionalJudgementOnMeritsInfoForm,
        [JUDGEMENT_INFO_FIELDS.DEPENS]: JUDGEMENT_ON_MERITS_ADDITIONAL_INFO_NOT_SELECTED,
        [JUDGEMENT_INFO_FIELDS.COST]: null,
      });
    }
  };

  const handleIddChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setIdd(event.target.value);
    if (event.target.value) {
      setAdditionalJudgementOnMeritsInfoForm({
        ...additionalJudgementOnMeritsInfoForm,
        [JUDGEMENT_INFO_FIELDS.IDD]: JUDGEMENT_ON_MERITS_ADDITIONAL_INFO_SELECTED,
      });
    } else {
      setAdditionalJudgementOnMeritsInfoForm({
        ...additionalJudgementOnMeritsInfoForm,
        [JUDGEMENT_INFO_FIELDS.IDD]: JUDGEMENT_ON_MERITS_ADDITIONAL_INFO_NOT_SELECTED,
        [JUDGEMENT_INFO_FIELDS.DATE]: null,
      });
    }
  };

  const setDocument = (document: CorporealDocument) => {
    if (CORRECTIONAL_DOC_ID === documentId) {
      setJudgementOnMeritsFormDocument(document);
      handleJudgementOnMeritsDocChange(document);
      resetUploadedDocument();
    }
  };

  const judgementOnMeritsSupportDocuments = get(
    judgementOnMerits,
    'judgementOnMerits.jom.supportDocuments',
    [],
  ).filter((el: any) =>
    el.type === props.isAppeal
      ? DOCUMENT_TYPES.SUPPORT_DOCUMENT_APPEAL_ON_MERITS
      : DOCUMENT_TYPES.SUPPORT_DOCUMENT_JUDGEMENT_ON_MERITS,
  );

  const [supportDocument, setSupportDocument] = useState({
    ...EMPTY_SUPPORT_DOC,
  });

  const setJudgementOnMeritsSupportDocument = (document: CorporealDocument) => {
    if (SUPPORT_DOC_JUDGEMENT_ON_MERITS_ID === documentId) {
      setSupportDocument(document);
      props.requestAddJudgementOnMeritsSupportDocument &&
        props.requestAddJudgementOnMeritsSupportDocument({
          ...document,
          status: isManager ? STATUS_VALIDATED : STATUS_PENDING,
          judgementOnMeritsId: get(
            judgementOnMerits,
            'judgementOnMerits.jom.id',
          ),
          claimId: props.claimId,
          claimNumber: props.claimNumber,
        });
      resetUploadedDocument();
    }
  };
  return (
    <>
      <div className="correctional-judgement">
        <FormControl className="formEl">
          <InputLabel id="depens-label-id">
            {translate(messages.judgementOnMeritsDepensFieldTitle, props)}
          </InputLabel>
          <Select
            labelId="depens-label-id"
            onChange={handleDepensChange}
            value={depens}
            labelWidth={LABEL_WIDTH}
          >
            <MenuItem key={0} value={1}>
              {translate(messages.yes, props)}
            </MenuItem>
            <MenuItem key={1} value={0}>
              {translate(messages.no, props)}
            </MenuItem>
          </Select>
        </FormControl>

        {!!depens && (
          <div className="judgement-on-merits-info">
            <TextField
              id="cost"
              name={JUDGEMENT_INFO_FIELDS.COST}
              label={translate(messages.judgementOnMeritsCostFieldTitle, props)}
              onChange={handleChange}
              value={judgementInfo[JUDGEMENT_INFO_FIELDS.COST]}
            />
          </div>
        )}
        <FormControl>
          <InputLabel id="idd-label-id">
            {translate(messages.judgementOnMeritsIddFieldTitle, props)}
          </InputLabel>
          <Select
            labelId="idd-label-id"
            onChange={handleIddChange}
            value={idd}
            labelWidth={LABEL_WIDTH}
          >
            <MenuItem key={0} value={1}>
              {translate(messages.yes, props)}
            </MenuItem>
            <MenuItem key={1} value={0}>
              {translate(messages.no, props)}
            </MenuItem>
          </Select>
        </FormControl>

        {!!idd && (
          <div className="judgement-on-merits-info">
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
              <KeyboardDatePicker
                autoOk
                variant="inline"
                format={DATE_PICKET_FORMAT}
                id="judgement-info-date"
                onChange={handleChangeDate}
                value={dateStringToLocalDate(
                  judgementInfo[JUDGEMENT_INFO_FIELDS.DATE],
                )}
                label={translate(messages.judgementInfoDate, props)}
                error={
                  dateStringToLocalDate(
                    judgementInfo[JUDGEMENT_INFO_FIELDS.DATE],
                  ) === 'Invalid date'
                }
                helperText={
                  dateStringToLocalDate(
                    judgementInfo[JUDGEMENT_INFO_FIELDS.DATE],
                  ) === 'Invalid date' && translate(messages.invalidDate, props)
                }
              />
            </MuiPickersUtilsProvider>
          </div>
        )}
        <div className="judgement-on-merits-info">
          <TextField
            id="commentary"
            name={JUDGEMENT_INFO_FIELDS.COMMENTARY}
            label={translate(
              messages.judgementOnMeritsCommentaryFieldTitle,
              props,
            )}
            onChange={handleCommentaryChange}
            value={judgementInfo[JUDGEMENT_INFO_FIELDS.COMMENTARY]}
          />
        </div>
        <br />
        <div>
          <div className="judgement-on-merits-info-conclusion">
            <FormControlLabel
              control={
                <Checkbox
                  name={JUDGEMENT_INFO_FIELDS.DEFENSE_TO_EXECUTION}
                  checked={
                    judgementInfo[JUDGEMENT_INFO_FIELDS.DEFENSE_TO_EXECUTION]
                  }
                  onChange={handleCheckBoxChangeDefenseToExecution}
                  color="primary"
                />
              }
              label={translate(
                messages.judgementOnMeritsDefenseToExecutionFieldTitle,
                props,
              )}
            />
          </div>
          <div className="judgement-on-merits-info-conclusion">
            <FormControlLabel
              control={
                <Checkbox
                  name={JUDGEMENT_INFO_FIELDS.DIFFICULTY_TO_EXECUTION}
                  checked={
                    judgementInfo[JUDGEMENT_INFO_FIELDS.DIFFICULTY_TO_EXECUTION]
                  }
                  onChange={handleCheckBoxChangeDifficultyToExecution}
                  color="primary"
                />
              }
              label={translate(
                messages.judgementOnMeritsDifficultyToExecutionFieldTitle,
                props,
              )}
            />
          </div>
        </div>
      </div>
      <div className="add-recap-bloc-title">
        {translate(
          isCivilProceeding || !isManager
            ? messages.judiciaryDocumentUpdate
            : messages.judiciaryDocument,
          props,
        )}
      </div>
      {judgementOnMerits['judgementOnMerits']['jom']['document'] && (
        <div className="judgement-on-merits-doc-info-wrapper">
          <div>
            <Document
              name={get(judgementOnMerits['judgementOnMerits']['jom'], [
                'document',
                'name',
              ])}
              type={get(judgementOnMerits['judgementOnMerits']['jom'], [
                'document',
                'type',
              ])}
              icon={
                <VisibilityIcon
                  className="consult"
                  onClick={handleOpenDocument(
                    get(judgementOnMerits['judgementOnMerits']['jom'], [
                      'document',
                    ]),
                    props.requestGetDocByDocumentumId,
                  )}
                />
              }
            />
          </div>
          {(isCivilProceeding || !isManager) &&
            props.isAssignedLawyer &&
            props.isCreator &&
            !isMonitoringCourtManager() && (
              <div>
                <UploadDocumentBloc
                  index={0}
                  document={judgementOnMeritsFormDocument}
                  setDocument={setDocument}
                  resetUploadedDocument={resetUploadedDocument}
                  uploadDocument={uploadDocument}
                  uploadedDocument={uploadedDocument}
                  docType={DOCUMENT_TYPES.CIVIL_JUDGEMENT}
                  setDocumentId={setDocumentId}
                  docId={CORRECTIONAL_DOC_ID}
                  shouldNotDisplayUploadTitle
                />
              </div>
            )}
        </div>
      )}
      {featureService.hasFeature(FEATURES.ADD_SUPPORT_DOCUMENTS) &&
        props.isAssignedLawyer &&
        !isMonitoringCourtManager() && (
          <main>
            {isEmpty(judgementOnMeritsSupportDocuments) && (
              <section className="add-recap-bloc">
                {resetUploadedDocument && uploadDocument && uploadedDocument && (
                  <>
                    <div className="add-recap-bloc-title">
                      {translate(messages.supportDocument, props)}
                    </div>

                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      spacing={2}
                    >
                      <Grid item xs={4}>
                        <UploadDocumentBloc
                          index={1}
                          document={supportDocument}
                          setDocument={setJudgementOnMeritsSupportDocument}
                          resetUploadedDocument={resetUploadedDocument}
                          uploadDocument={uploadDocument}
                          uploadedDocument={uploadedDocument}
                          docType={
                            props.isAppeal
                              ? DOCUMENT_TYPES.SUPPORT_DOCUMENT_APPEAL_ON_MERITS
                              : DOCUMENT_TYPES.SUPPORT_DOCUMENT_JUDGEMENT_ON_MERITS
                          }
                          setDocumentId={setDocumentId}
                          docId={SUPPORT_DOC_JUDGEMENT_ON_MERITS_ID}
                        />
                      </Grid>
                      <Grid item xs={3} style={{ marginTop: '20px' }}>
                        {!isEmpty(props.imagineDocuments) &&
                          featureService.hasFeature(
                            FEATURES.TRAITEMENT_IMAGINE_DOC,
                          ) &&
                          isManager && (
                            <ImportImagineDocumentButton
                              listings={props.listings}
                              managerNotifcationsInboxes={
                                props.imagineDocuments
                              }
                              claimId={props.claimId}
                              imagineDocuments={props.imagineDocuments}
                              claimSagisInfo={resolveSagisClaim(
                                props.policyInfo,
                              )}
                              uploadDocument={uploadDocument}
                              uploadedDocument={uploadedDocument}
                              setUploadedDocs={
                                setJudgementOnMeritsSupportDocument
                              }
                              documentName={
                                props.isAppeal
                                  ? DOCUMENT_TYPES.SUPPORT_DOCUMENT_APPEAL_ON_MERITS
                                  : DOCUMENT_TYPES.SUPPORT_DOCUMENT_JUDGEMENT_ON_MERITS
                              }
                              documentType={
                                props.isAppeal
                                  ? DOCUMENT_TYPES.SUPPORT_DOCUMENT_APPEAL_ON_MERITS
                                  : DOCUMENT_TYPES.SUPPORT_DOCUMENT_JUDGEMENT_ON_MERITS
                              }
                              setDocumentId={setDocumentId}
                              documentId={SUPPORT_DOC_JUDGEMENT_ON_MERITS_ID}
                              requestGetDocByDocumentumId={
                                props.requestGetDocByDocumentumId
                              }
                            />
                          )}
                      </Grid>
                    </Grid>
                  </>
                )}
              </section>
            )}
          </main>
        )}
      {featureService.hasFeature(FEATURES.ADD_SUPPORT_DOCUMENTS) &&
        !isEmpty(judgementOnMeritsSupportDocuments) && (
          <section className="add-recap-bloc">
            <div className="add-recap-bloc-title">
              {translate(messages.supportDocument, props)}
            </div>
            <div className="judgement-on-merits-doc-info">
              <Document
                name={get(judgementOnMeritsSupportDocuments[0], 'name', '')}
                type={get(judgementOnMeritsSupportDocuments[0], 'type', '')}
                icon={
                  <VisibilityIcon
                    className="consult"
                    onClick={handleOpenDocument(
                      judgementOnMeritsSupportDocuments[0],
                      props.requestGetDocByDocumentumId,
                    )}
                  />
                }
              />
              {!isMonitoringCourtManager() && !props.isConsultation && (
                <DecisionDropDownSupportDocument
                  claimId={props.claimId as any}
                  claimNumber={props.claimNumber as any}
                  judiciaryProcessId={props.judiciaryProcessId}
                  supportDocument={judgementOnMeritsSupportDocuments[0]}
                  requestMakeDecisionSupportDocument={
                    props.requestMakeDecisionSupportDocument
                  }
                  claim={props.claim}
                  procedureType={
                    props.isAppeal
                      ? PROCEDURE_TYPES.APPEAL
                      : PROCEDURE_TYPES.FIRST_INSTANCE
                  }
                />
              )}
            </div>
          </section>
        )}
    </>
  );
};

export default injectIntl(AdditionalInfoJudgementOnMeritForm);
